






























































import { Component, Prop, Vue } from "vue-property-decorator";
import { IRoomControl } from "@/@types/hotel/room";

import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import ContextMenu from "@/components/buttons/context-menu.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";

@Component({
  name: "room-control",
  components: { ChangeDeliteButtons, BSwitch, ContextMenu },
})
export default class RoomControl extends Vue {
  @Prop({ type: Array, default: () => [] }) statuses!: Array<IRoomControl>;
  @Prop({ type: Boolean, default: false }) deleted!: boolean;
  constxtID = "";

  $refs!: {
    menu: ContextMenu;
  };

  handler(e: PointerEvent, id: string | undefined): void {
    e.preventDefault();
    if (!id) return;
    this.$nextTick(() => {
      this.$refs.menu.contextX = e.clientX;
      this.$refs.menu.contextY = e.clientY;
      this.$refs.menu.showContext = true;
      this.constxtID = id;
    });
  }

  changeElement(id: string, type: boolean): void {
    if (!type) this.$emit("deleteElement", id);
    else this.$emit("changeElement", id);
  }

  restoreElement(id: string): void {
    this.$emit("restoreElement", id);
  }
}
